/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import Select from "react-select";
import config from "../../config/config";
import { useSelector } from 'react-redux';
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import { MESSAGE_TYPE } from "../../constants";
import axios from "axios";

import "./O2CMainComp.css";
import styles from "./O2CMainComp.module.css";
import DomainTile from "../../components/DomainTile/DomainTile";
import BarLineChartO2C from "./BarLineChartO2C";
import DashboardSection from "../../components/DashboardContainer/DashboardSection";

const { API_BASE_URL } = config;

function O2CAfterSalesComp() {

  const quarterOptionss = [
    { value: "2", label: "Q1" },
    { value: "3", label: "Q2" },
    { value: "4", label: "Q3" },
    { value: "1", label: "Q4" },
  ];
  
  const quarterToMonths = {
    2: [4, 5, 6],  // Apr–Jun
    3: [7, 8, 9],  // Jul–Sep
    4: [10, 11, 12], // Oct–Dec
    1: [1, 2, 3]   // Jan–Mar
  };

  const allMonths = [
    { label: 'Jan', value: 1 },
    { label: 'Feb', value: 2 },
    { label: 'Mar', value: 3 },
    { label: 'Apr', value: 4 },
    { label: 'May', value: 5 },
    { label: 'Jun', value: 6 },
    { label: 'Jul', value: 7 },
    { label: 'Aug', value: 8 },
    { label: 'Sep', value: 9 },
    { label: 'Oct', value: 10 },
    { label: 'Nov', value: 11 },
    { label: 'Dec', value: 12 },
  ];

  const token = useSelector((state) => state.auth.djangoAccessToken);
  const roles = useSelector((state) => state.auth.djangoRoles);
  const userInfo = useSelector((state) => state.auth.djangoUserInfo);

  const location = useLocation();
  const { showPopup } = usePopupManager();

  const initialFilters = location.state || {
    entityData: null,
    yearData: null,
    quarterData: [],
    monthData: [],
  };

  const [hasApplied, setHasApplied] = useState(false);

  const [filters, setFilters] = useState(initialFilters);

  const [showDashboard, setShowDashboard] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [entityOptions, setEntityOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  const [monthOptions, setMonthOptions] = useState(allMonths);
  const [quarterOptions, setQuarterOptions] = useState(quarterOptionss);

  const [entity, setEntity] = useState(null);
  const [year, setYear] = useState(null);
  const [month, setMonth] = useState([]);
  const [quarter, setQuarter] = useState([]);

  const [afterSalesClaimMgmt,setAfterSalesClaimMgmt] = useState([]);
  const [afterSalesBlockUnblock,setAfterSalesBlockUnblock] = useState([]);
  const [afterSalesAMCAutomatic,setAfterSalesAMCAutomatic] = useState([]);
  const [afterSalesAMCManual,setAfterSalesAMCManual] = useState([]);

  const handleEntityChange = (selected) => {
    setEntity(selected);
    setFilters(prev => ({ ...prev, entityData: selected }));
  };

  const handleYearChange = (selected) => {
    setYear(selected);
    setFilters(prev => ({ ...prev, yearData: selected }));
  };

  const handleQuarterChange = (selected) => {
    if (selected && selected.length > 0) {
      setQuarter(selected);
      setFilters(prev => ({ ...prev, quarterData: selected }));

      const selectedMonths = selected.flatMap(q => quarterToMonths[q.value]);

      const updatedMonths = monthOptions.filter(m => selectedMonths.includes(m.value));

      setMonth(updatedMonths);
      setFilters(prev => ({
        ...prev,
        monthData: updatedMonths,
      }));
    } else {
      setQuarter([]);
      setMonth([]);
      setFilters(prev => ({...prev,quarterData: [],monthData: []}));
    }
  };

  const handleMonthChange = (selected) => {
    const updatedMonths = selected || [];
    setMonth(updatedMonths);
    setFilters(prev => ({ ...prev, monthData: updatedMonths }));
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: '20px',
      flexWrap: 'wrap',
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: '50px',
      overflowY: 'auto',
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      overflow: 'visible',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
    }),
    option: (provided) => ({
      ...provided,
      padding: '8px 12px',
    }),
  };

  const handleApply = () => {
    const entityFilterData = entity?.value || '';
    const yearFilterData = year?.value || '';
    const monthFilterData = month?.map(m => m?.value) || []; 
    const quarterData = quarter?.map(q => q?.value) || [];

    if (entityFilterData === ''){
          showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: "Please select entity.",
            });
          return;
        }

    if (yearFilterData === ''){
        showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: "Please select Fiscal year.",
          });
        return;
      }
      
    setIsLoading(true);

    const fetchAfterSalesClaimMgmt = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}/api/O2C-aftersales-claimmgmt`, 
          { 
            selectedEntity: entityFilterData,
            selectedYear: yearFilterData,
            selectedMonth: monthFilterData,
            selectedQuarter: quarterData,
          },
          {headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: 'Basic YWRtaW4xOjEyMw==',
          }},
        )
        .then((response) => {
          const result = response.data;
          setAfterSalesClaimMgmt(result)
        })
      } catch (error) {
        console.error('Error fetching After Sales Claim Mgmt Drilldown options:', error);
      }
    };

    const fetchAfterSalesBlockUnblock = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}/api/O2C-aftersales-blockunblock`, 
          { 
            selectedEntity: entityFilterData,
            selectedYear: yearFilterData,
            selectedMonth: monthFilterData,
            selectedQuarter: quarterData,
          },
          {headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: 'Basic YWRtaW4xOjEyMw==',
          }},
        )
        .then((response) => {
          const result = response.data;
          setAfterSalesBlockUnblock(result)
        })
      } catch (error) {
        console.error('Error fetching After Sales Block/Unblock Drilldown options:', error);
      }
    };

    const fetchAfterSalesAMCAutomatic = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}/api/O2C-aftersales-amcautomatic`, 
          { 
            selectedEntity: entityFilterData,
            selectedYear: yearFilterData,
            selectedMonth: monthFilterData,
            selectedQuarter: quarterData,
          },
          {headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: 'Basic YWRtaW4xOjEyMw==',
          }},
        )
        .then((response) => {
          const result = response.data;
          setAfterSalesAMCAutomatic(result)
        })
      } catch (error) {
        console.error('Error fetching After Sales AMC Automatic Drilldown options:', error);
      }
    };

    const fetchAfterSalesAMCManual = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}/api/O2C-aftersales-amcmanual`, 
          { 
            selectedEntity: entityFilterData,
            selectedYear: yearFilterData,
            selectedMonth: monthFilterData,
            selectedQuarter: quarterData,
          },
          {headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: 'Basic YWRtaW4xOjEyMw==',
          }},
        )
        .then((response) => {
          const result = response.data;
          setAfterSalesAMCManual(result)
        })
      } catch (error) {
        console.error('Error fetching After Sales AMC Manual Drilldown options:', error);
      }
    };

    Promise.all([fetchAfterSalesClaimMgmt(),fetchAfterSalesBlockUnblock(),fetchAfterSalesAMCAutomatic(),fetchAfterSalesAMCManual()]).then(() => {
      setShowDashboard(true);
      setIsLoading(false);
    });
  };

  const handleReset = () => {
    setEntity(null);
    setYear(null);
    setQuarter([]);
    setMonth([]);
    setFilters({
      entityData: null,
      yearData: null,
      quarterData: [],
      monthData: [],
    });
    setShowDashboard(false);
  };

  const fetchEntityOptions = async () => {
    try {
      const response = await axios
        .get(`${API_BASE_URL}/api/O2C-entity`, {
          headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: "Basic YWRtaW4xOjEyMw==",
          },
        })
        .then((response) => {
          setEntityOptions(response.data);
        });
    } catch (error) {
      console.error("Error fetching O2C-entity options:", error);
    }
  };

  const fetchYearOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/O2C-year`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
      .then((response) => {
        setYearOptions(response.data);
      })
    } catch (error) {
      console.error('Error fetching O2C-year options:', error);
    }
  };

  useEffect(()=>{
    fetchEntityOptions();
    fetchYearOptions();
  },[]);

  useEffect(() => {

    if (entityOptions.length && quarterOptions.length && yearOptions.length && monthOptions.length) {

      if (filters.entityData?.value) {
        const ent = entityOptions.find(opt => opt.value === filters.entityData.value);
        if (ent) setEntity(ent);
      }
  
      if (filters.yearData?.value) {
        const yr = yearOptions.find(opt => opt.value === filters.yearData.value);
        if (yr) setYear(yr);
      }

      if (filters.monthData && filters.monthData.length > 0) {
        const mon = monthOptions.filter(opt =>
          filters.monthData.some(m => m.value === opt.value)
        );
        if (mon.length > 0) setMonth(mon);
      }

      if (filters.quarterData && filters.quarterData.length > 0) {
            const qtr = quarterOptions.filter(opt =>
              filters.quarterData.some(q => q.value === opt.value)
            );
            if (qtr.length > 0) setQuarter(qtr);
          }

      if (filters.entityData?.value) {
        setTimeout(() => {
          setHasApplied(true);
        }, 1000);
      }
    }
  }, [entityOptions, yearOptions,quarterOptions, monthOptions]);

  useEffect(() => {
    if (hasApplied === true ) {
      handleApply();
      setHasApplied(false);
    }
  }, [hasApplied]);


  const afterSalesClaimMgmtDatasets = [
    {
      type: "line",
      label: "Accuracy %",
      data: afterSalesClaimMgmt?.map((item) => item.accuracy),
      borderColor: "#90EE90",
      backgroundColor: "#90EE90",
      yAxisID: "y1",
      tension: 0.3,
      pointRadius: 5,
      // datalabels: {
      //   display: false,
      // },
    },
    {
      type: "line",
      label: "Timeliness %",
      data: afterSalesClaimMgmt?.map((item) => item.timeliness),
      borderColor: "#800080",
      backgroundColor: "#800080",
      yAxisID: "y1",
      tension: 0.3,
      pointRadius: 9,
      // datalabels: {
      //   display: false,
      // },
    },
    {
      type: "line",
      label: "% of Queries Returned",
      data: afterSalesClaimMgmt?.map((item) => item.returned),
      borderColor: "#FFA500",
      backgroundColor: "#FFA500",
      yAxisID: "y1",
      tension: 0.3,
      pointRadius: 7,
      // datalabels: {
      //   display: false,
      // },
    },
    {
      type: "bar",
      label: "Within SLA",
      data: afterSalesClaimMgmt?.map((item) => item.within_sla_count),
      backgroundColor: "#0072CE",
    },
    {
      type: "bar",
      label: "Outside SLA",
      data: afterSalesClaimMgmt?.map((item) => item.outside_sla_count),
      backgroundColor: "#FF0000",
    },
  ];

  const afterSalesBlockUnblockDatasets = [
    {
      type: "line",
      label: "Timeliness %",
      data: afterSalesBlockUnblock?.map((item) => item.timeliness),
      borderColor: "#800080",
      backgroundColor: "#800080",
      yAxisID: "y1",
      tension: 0.3,
      pointRadius: 5,
      // datalabels: {
      //   display: false,
      // },
    },
    {
      type: "bar",
      label: "Within SLA",
      data: afterSalesBlockUnblock?.map((item) => item.within_sla_count),
      backgroundColor: "#0072CE",
    },
    {
      type: "bar",
      label: "Outside SLA",
      data: afterSalesBlockUnblock?.map((item) => item.outside_sla_count),
      backgroundColor: "#FF0000",
    },
  ];

  const afterSalesAMCAutomaticDatasets = [
    {
      type: "line",
      label: "Accuracy %",
      data: afterSalesAMCAutomatic?.map((item) => item.accuracy),
      borderColor: "#90EE90",
      backgroundColor: "#90EE90",
      yAxisID: "y1",
      tension: 0.3,
      pointRadius: 5,
      // datalabels: {
      //   display: false,
      // },
    },
    {
      type: "bar",
      label: "Within SLA",
      data: afterSalesAMCAutomatic?.map((item) => item.within_sla_count),
      backgroundColor: "#0072CE",
    },
    {
      type: "bar",
      label: "Outside SLA",
      data: afterSalesAMCAutomatic?.map((item) => item.outside_sla_count),
      backgroundColor: "#FF0000",
    },
  ];

  const afterSalesAMCManualDatasets = [
    {
      type: "line",
      label: "Accuracy %",
      data: afterSalesAMCManual?.map((item) => item.accuracy),
      borderColor: "#90EE90",
      backgroundColor: "#90EE90",
      yAxisID: "y1",
      tension: 0.3,
      pointRadius: 5,
      // datalabels: {
      //   display: false,
      // },
    },
    {
      type: "line",
      label: "Timeliness %",
      data: afterSalesAMCManual?.map((item) => item.timeliness),
      borderColor: "#800080",
      backgroundColor: "#800080",
      yAxisID: "y1",
      tension: 0.3,
      pointRadius: 8,
      // datalabels: {
      //   display: false,
      // },
    },
    {
      type: "bar",
      label: "Within SLA",
      data: afterSalesAMCManual?.map((item) => item.within_sla_count),
      backgroundColor: "#0072CE",
    },
    {
      type: "bar",
      label: "Outside SLA",
      data: afterSalesAMCManual?.map((item) => item.outside_sla_count),
      backgroundColor: "#FF0000",
    },
  ];

  return (
    <>
      <div className={styles.filter_panel_container}>
        <div className={styles.filter_panel_row}>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Entity<span style={{ color: 'red' }}>*</span></label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={entity}
                onChange={handleEntityChange}
                options={entityOptions}
                isSearchable={true}
                // isMulti={true}
                // closeMenuOnSelect={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Fiscal Year<span style={{ color: 'red' }}>*</span></label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={year}
                onChange={handleYearChange}
                options={yearOptions}
                isSearchable={true}
                // isMulti={true}
                // closeMenuOnSelect={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Quarter</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={quarter}
                onChange={handleQuarterChange}
                options={quarterOptions}
                isSearchable={true}
                isMulti={true}
                closeMenuOnSelect={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Month</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={month}
                onChange={handleMonthChange}
                options={monthOptions}
                isSearchable={true}
                isMulti={true}
                closeMenuOnSelect={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className="filter-panel-col action-buttons">
            <button onClick={handleApply} className="btn apply-btn">
              Apply
            </button>
            <button onClick={handleReset} className="btn reset-btn">
              Reset
            </button>
          </div>
        </div>
      </div>
      {isLoading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div className="text-center">
            <div className="spinner-border text-primary mb-3" role="status"></div>
            <p className="mb-3" style={{ fontSize: "18px", fontWeight: "bold", color: "#0067ac" }}>Loading...</p>     
          </div>
        </div>
      )}
      {showDashboard && (
      <>
        <div className="row">
          <div className="col-md-12">
            <DomainTile title="After Sales" showBackButton={true} mainPagePath="/Order-To-Cash" detailState = {filters}/>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 mb-4">
            <DashboardSection
              title="Claims Management"
              disableDetailView={true}
              detailPath="/Procure-To-Pay"
              infoIcondata = "Manual CSV + SAP Data"
            >
              <BarLineChartO2C
                datasets={afterSalesClaimMgmtDatasets}
                chartData={afterSalesClaimMgmt}
                height={250}
                minval={0}
              />
            </DashboardSection>
          </div>
          <div className="col-lg-6 mb-4">
            <DashboardSection
              title="Blocking / Unblocking of Customer Code"
              disableDetailView={true}
              detailPath="/Procure-To-Pay"
              infoIcondata = "Manual CSV Data"
            >
              <BarLineChartO2C
                datasets={afterSalesBlockUnblockDatasets}
                chartData={afterSalesBlockUnblock}
                height={250}
                minval={0}
              />
            </DashboardSection>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 mb-4">
            <DashboardSection
              title="Automatic AMC Bookings"
              disableDetailView={true}
              detailPath="/Procure-To-Pay"
              infoIcondata = "Manual CSV Data"
            >
              <BarLineChartO2C
                datasets={afterSalesAMCAutomaticDatasets}
                chartData={afterSalesAMCAutomatic}
                height={250}
                minval={0}
              />
            </DashboardSection>
          </div>
          <div className="col-lg-6 mb-4">
            <DashboardSection
              title="Manual AMC Bookings"
              disableDetailView={true}
              detailPath="/Procure-To-Pay"
              infoIcondata = "Manual CSV Data"
            >
              <BarLineChartO2C
                datasets={afterSalesAMCManualDatasets}
                chartData={afterSalesAMCManual}
                height={250}
                minval={0}
              />
            </DashboardSection>
          </div>
        </div>
      </>
      )}
    </>
  );
}

export default O2CAfterSalesComp;